// url.js
import { BASE_URL } from './root_url';
export const MOBILE_URL = `${BASE_URL}/v1/mobile`;

// auth
export const CHECK_TAKEN = `${BASE_URL}/v1/baseuser/checktaken/`;
export const FORGET_USERNAME_URL = `${BASE_URL}/v1/mobile/account/forgot-username/`;
export const FORGET_PASSWORD_URL = `${BASE_URL}/v1/mobile/account/forgot-password/`;
export const LOGIN_URL = `${BASE_URL}/api-token-auth/`;
export const ADMIN_LOGIN_URL = `${BASE_URL}/api-token-auth-admin/`;
export const RESET_PASSWORD_URL = `${MOBILE_URL}/account/change-password/`;
export const RESET_EMAIL_URL = `${MOBILE_URL}/account/req-reset-password/`;
export const RESET_PASSWORD = `${MOBILE_URL}/account/reset-password/`;
export const SIGNUP_URL = `${BASE_URL}/v1/baseuser/register/customer/`;
export const SEND_VERIFICATION_CODE = `${MOBILE_URL}/account/verify-active/`;
export const CHANGE_PASSWORD = `${MOBILE_URL}/account/change-password/`;

// profile
export const ADDRESS_URL = `${MOBILE_URL}/address`;
export const CUSTOMER_INFORMATION_URL = `${BASE_URL}/v1/customer/oao/`;
export const DEFAULT_ADDRESS_URL = `${MOBILE_URL}/address/default`;
export const USER_CONFIG_URL = `${MOBILE_URL}/user_config`;
export const VERIFY_EMAIL_URL = `${MOBILE_URL}/account/verify_email_req`;
export const UPDATE_USER_PHOTO = `${MOBILE_URL}/account/upload_profile`;
export const BALENCE_URL = `${BASE_URL}/v1/customer/balance/`;

// product
export const BILLBOARD_URL = `${MOBILE_URL}/billboard/`;
export const CATEGORY_URL = `${MOBILE_URL}/category/`;
export const PRODUCTS_URL = `${MOBILE_URL}/product/`;
export const SEARCH_PRODUCT_URL = `${MOBILE_URL}/product/?Name=`;
export const PRODUCTS_GROUP = `${MOBILE_URL}/group`;
export const PRODUCT_LIST_URL = `${MOBILE_URL}/customer-overseas-products`;
export const PRODUCT_DETAIL_URL = `${MOBILE_URL}/customer-overseas-products?product_id=`;
export const INBOUND_PRODUCT_URL = `${BASE_URL}/v2/sales/inbound-order-products`;

// checkout
export const ANYWHERE_COMMERCE_URL = `${BASE_URL}/v1/acpayment/store_card/`;
export const CHECKOUT_URL = `${MOBILE_URL}/order/`;
export const CHECKOUT_TOUR_URL = `${MOBILE_URL}/consolidated-checkout/`;
export const VALIDATE_DELIVERY_RADIUS_URL = `${MOBILE_URL}/check_address_location`;
export const VALIDATE_PROMO_CODE_URL = `${MOBILE_URL}/promocode`;
export const ZIPCODE_URL = `${BASE_URL}/v1/purchase/taxarea/`
export const ZIPCODE_URL_NO_LOGIN = `${BASE_URL}/v1/purchase/taxareanotlogin/`

// order
export const CONSOLIDATED_ORDERS_URL = `${MOBILE_URL}/consolidated-orders`;
export const DISPATCH_PORTAL_URL = `${BASE_URL}/v1/sale/sales_mobile_order/external`;
export const MOBILE_SALES_ORDERS_URL = `${BASE_URL}/v1/sale/sales_mobile_order/search/`;
export const ORDER_URL = `${MOBILE_URL}/order/`;
export const PENDING_ORDERS_URL = `${MOBILE_URL}/pending-orders`;
export const SALES_ORDER_URL = `${MOBILE_URL}/sales_order/`;
export const SALES_INVOICE_URL = `${MOBILE_URL}/sales_invoice/`;
export const ADDRESS_AUTOCOMPLETE_URL = `${BASE_URL}/v1/customer/address-auto-complete`;
export const ADDRESS_AUTOCOMPLETE_DETAIL_URL= `${BASE_URL}/v1/customer/address-auto-complete-detail`;
export const DSQ_ORDER_URL= `${BASE_URL}/v1/mobile/dsq-order/`;
export const DSQ_FILE_URL= `${BASE_URL}/v1/mobile/dsq-file-convert/`;
export const INBOUND_URL= `${BASE_URL}/v1/mobile/inbound-order/`;
export const INBOUND_INVENTORY_URL= `${BASE_URL}/v1/mobile/inbound-inventory`;
export const OVERSEAS_ORDER_URL= `${BASE_URL}/v1/mobile/overseas-order/`;
export const UPLOAD_ORDER_FILE_URL= `${BASE_URL}/v2/sales/order-file-upload/`;

export const GET_QUOTE_URL = `${BASE_URL}/v2/sale/shipping/xpo_quote/`;
export const YING_BOL_URL = `${BASE_URL}/v2/sale/shipping/xpo_bol/`;
export const GET_PICKUP_URL = `${BASE_URL}/v2/sale/shipping/xpo_pickup/`;
export const TRACKING_URL = `${BASE_URL}/v2/sale/shipping/xpo_tracking/`;
export const XPO_TOKEN_URL = `${BASE_URL}/v2/get_xpo_token`;
export const XPO_DOC_URL = `https://api.ltl.xpo.com/imaging/1.0/shipments/`;

// contact
export const CONTACT_URL = `${BASE_URL}/v1/contact/info/`;

//cart
export const CART_URL = `${BASE_URL}/v1/mobile/cart`;

//become a driver
export const DRIVERAPPLY = `${BASE_URL}/v1/baseuser/mmdriver-application`;

//warehouse
export const WAREHOUSE_LIST_URL = `${BASE_URL}/v2/warehouse/`;
 
export const WAREHOUSE_ADDRESS_URL = `${BASE_URL}/v1/oversea-warehouse/amazon-fba-address`;
export const WAREHOUSE_UNIT_PRICE_URL = `${BASE_URL}/v1/oversea-warehouse/products`;
export const WAREHOUSE_PLACE_ORDER_URL = `${BASE_URL}/v1/oversea-warehouse/place-order`;
export const WAREHOUSE_PAYMENT_URL = `${BASE_URL}/v1/oversea-warehouse/payment`;
export const WAREHOUSE_ORDER_HISTORY_URL = `${BASE_URL}/v1/oversea-warehouse/order-history`
export const WAREHOUSE_ORDER_DETAIL_URL = `${BASE_URL}/v1/oversea-warehouse/order-history-detail`
export const WAREHOUSE_TRACK_LOG_URL = `${BASE_URL}/v1/oversea-warehouse/get-tracking-log`
export const WAREHOUSE_PRINT_BOL_URL = `${BASE_URL}/v1/oversea-warehouse/printing-so-bol-file/`



// WEBPACK FOOTER //
// ./src/api/url.js